/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DisconnectApiV1SandboxGithubOauthConnectionsDeleteRequest = {
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const DisconnectApiV1SandboxGithubOauthConnectionsDeleteRequest$inboundSchema:
  z.ZodType<
    DisconnectApiV1SandboxGithubOauthConnectionsDeleteRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    "X-On-Behalf-Of": z.string().optional(),
  }).transform((v) => {
    return remap$(v, {
      "X-On-Behalf-Of": "xOnBehalfOf",
    });
  });
/** @internal */
export type DisconnectApiV1SandboxGithubOauthConnectionsDeleteRequest$Outbound =
  {
    "X-On-Behalf-Of"?: string | undefined;
  };

/** @internal */
export const DisconnectApiV1SandboxGithubOauthConnectionsDeleteRequest$outboundSchema:
  z.ZodType<
    DisconnectApiV1SandboxGithubOauthConnectionsDeleteRequest$Outbound,
    z.ZodTypeDef,
    DisconnectApiV1SandboxGithubOauthConnectionsDeleteRequest
  > = z.object({
    xOnBehalfOf: z.string().optional(),
  }).transform((v) => {
    return remap$(v, {
      xOnBehalfOf: "X-On-Behalf-Of",
    });
  });

export function disconnectApiV1SandboxGithubOauthConnectionsDeleteRequestToJSON(
  disconnectApiV1SandboxGithubOauthConnectionsDeleteRequest:
    DisconnectApiV1SandboxGithubOauthConnectionsDeleteRequest,
): string {
  return JSON.stringify(
    DisconnectApiV1SandboxGithubOauthConnectionsDeleteRequest$outboundSchema
      .parse(disconnectApiV1SandboxGithubOauthConnectionsDeleteRequest),
  );
}
export function disconnectApiV1SandboxGithubOauthConnectionsDeleteRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  DisconnectApiV1SandboxGithubOauthConnectionsDeleteRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      DisconnectApiV1SandboxGithubOauthConnectionsDeleteRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'DisconnectApiV1SandboxGithubOauthConnectionsDeleteRequest' from JSON`,
  );
}
